var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_vm._m(0),_c('div',{staticClass:"AuthorizationArea"},[_c('p',[_vm._v("有限会社 ゼンオキ食品")]),_c('p',{staticClass:"loginUser"},[_vm._v(_vm._s(_vm.employees_last_name+ " " + _vm.employees_first_name))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logoArea"},[_c('h1',[_vm._v("管理画面")])])
}]

export { render, staticRenderFns }